import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";
import { useJstReveal } from "../../hooks/useJstReveal";
import { JstShellContext } from "../../context/JstShellContext";
import SiteFooter from "../layout/SiteFooter";
import ShellPageAISection from "../common/ShellPageAISection";

/**
 * Outer wrapper for most routes: full-height column + site footer on every page.
 * Legacy pages may still mount Footer inside body_wrapper; CSS hides those duplicates.
 */
export default function LazyPageShell({ children, pathname: pathnameProp }) {
  const location = useLocation();
  const pathname = pathnameProp ?? location.pathname ?? "/";
  useJstReveal([pathname]);

  const showDepthCta = pathname !== "/contact" && pathname !== "/email";

  return (
    <JstShellContext.Provider value={{ showDepthCta, shellProvidesFooter: true }}>
      <div className="jst-page-shell">
        <div className="jst-shell-children">{children}</div>
        <ShellPageAISection pathname={pathname} />
        <SiteFooter />
      </div>
    </JstShellContext.Provider>
  );
}
